import { DrawCabinetFrontElement } from './DrawCabinetFrontElement';

export class DrawFrontHorizontalGroove extends DrawCabinetFrontElement {
}
